import { render, staticRenderFns } from "./SendRequestReplyMessage.vue?vue&type=template&id=54bfbf2c&scoped=true&lang=pug"
import script from "./SendRequestReplyMessage.vue?vue&type=script&lang=ts"
export * from "./SendRequestReplyMessage.vue?vue&type=script&lang=ts"
import style0 from "./SendRequestReplyMessage.vue?vue&type=style&index=0&id=54bfbf2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54bfbf2c",
  null
  
)

export default component.exports